// @flow

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  pt, px, mb, ml
} from 'styled-components-spacing';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { fontCopyDefault } from '@styles/typography';

import theme from '@theme';

const { colors } = theme;

export const StyledContent = styled.div`
  margin: auto;
  display: flex;

  ${pt(4.5)}
  ${px(4)}

  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const StyledTitle = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: ${colors.darkBlue};

  text-align: center;

  ${theme.typography.Raleway}

  ${mb(3)}
`;

export const StyledDescriptionText = styled.p`
  ${fontCopyDefault};
  text-align: center;

  ${mb(4)}
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  width: 100%;

  justify-content: space-between;

  a {
    width: 47%;
    width: calc(50% - 8px);
    height: 56px;
  }

  ${breakpoint('desktop')`
    justify-content: flex-end;

    a {
      width: 140px;
      ${ml(2)}
    }
  `}
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 48px;

  color: ${colors.aquaMarine};

  ${mb(3.5)}
`;
